import { flattenObject } from '@atlassian/mpac-utils/object';
export const appTrustDataTransformer = appTrustData => {
  const flattenedAppTrustData = flattenObject(appTrustData);
  return Object.fromEntries(Object.entries(flattenedAppTrustData).filter(_ref => {
    let [_, v] = _ref;
    return v != null;
  }));
};